// eslint-disable-next-line import/prefer-default-export
export const OIDCErrorCodesThatRequireSignin = [
  'interaction_required',
  'login_required',
  'account_selection_required',
  'consent_required',
];
